module.exports = __webpack_public_path__ + "img/step-5-s.653624e2.png";